import React from 'react';
import './CSS/BrandsPartnerships.css';
import watch1 from '../assets/images/watch1.png';
import watch2 from '../assets/images/watch2.png';

const BrandsPartnerships = () => {
  return (
    <section className="brands-partnerships-section">
      <div className="container">
        <div className="brands-partnerships-grid">
          {/* Left Column - London Racket Stringing Company */}
          <div className="brands-column brands-left" style={{ backgroundImage: `url(${watch2})` }}>
            <div className="brands-content">
              <h3 className="brands-title">London Racket Stringing Company</h3>
              <p className="brands-description">
                Your go-to destination for professional racket stringing and sports coaching in London. Whether you're a beginner or a pro, we bring precision, speed, and expertise to the court.
              </p>
            </div>
          </div>

          {/* Center Column - Main Content */}
          <div className="brands-column brands-center">
            <div className="brands-content">
              <h2 className="brands-main-title">
                Our Brands & <span className="text-primary">Partnerships</span>
              </h2>
              <p className="brands-main-description">
                We've expanded beyond tech into lifestyle<br/>
                and sports, creating specialized experiences<br/>
                through these growing brands:
              </p>
            </div>
          </div>

          {/* Right Column - Watch Company */}
          <div className="brands-column brands-right" style={{ backgroundImage: `url(${watch1})` }}>
            <div className="brands-content">
              <h3 className="brands-title">Premium Watch Experience</h3>
              <p className="brands-description">
                A premium watch experience featuring a curated collection of vintage and modern timepieces — from Rolex and Omega to Cartier and beyond. CN21 is where timeless design meets trust and craftsmanship.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsPartnerships;